import React, { MouseEvent } from "react";
import { RoundButtonTabs } from "../round-button-tabs/round-button-tabs";
import styles from "./label-plus-round-button-tabs.modules.scss";

const cssClassName = "label-plus-round-button-tabs";

interface RoundButtonTypes {
  name: string;
  value: string;
  selected: boolean;
}

interface LabelPlusRoundButtonTabsPropTypes {
  labelText: string;
  roundButtonTypesArray: RoundButtonTypes[];
  onClickHandler: (e: MouseEvent, buttonValue: string) => void;
}

export const LabelPlusRoundButtonTabs = ({ labelText, roundButtonTypesArray, onClickHandler }: LabelPlusRoundButtonTabsPropTypes) => {
  return (
    <div>
      <div className={styles[`${cssClassName}__extra-margin-bottom`]}>
        <div className={styles[`${cssClassName}__attribute-name`]}>{labelText}</div>
      </div>
      <div className={styles[`${cssClassName}__buttons-wrapper`]}>
        <RoundButtonTabs roundButtonTypesArray={roundButtonTypesArray} onClickHandler={onClickHandler} />
      </div>
    </div>
  );
}